/*
 * SIGGO — Valores: sincroniza el texto fijo con la imagen que se esta viendo.
 *
 * La caja de texto no se mueve (la deja quieta `position: sticky` en el CSS);
 * lo que cambia es CUAL de los paneles de texto esta visible. Cada panel
 * corresponde a una imagen de la columna izquierda.
 *
 * Por que un IntersectionObserver y no `animation-timeline: view()`:
 * las lineas de tiempo de scroll animan un elemento segun SU propia posicion,
 * asi que para encender el panel 2 haria falta que el panel leyera la posicion
 * de la imagen 2, que vive en otra rama del arbol. Eso obliga a `timeline-scope`
 * y a una linea de tiempo por imagen, con nombres distintos generados en
 * Liquid. El observador hace lo mismo con mucho menos que mantener y funciona
 * igual en todos los navegadores.
 */
(function () {
  if (customElements.get('siggo-valores-sync')) return;

  class SiggoValoresSync extends HTMLElement {
    connectedCallback() {
      this.medias = Array.from(this.querySelectorAll('[data-siggo-val-media]'));
      this.panels = Array.from(this.querySelectorAll('[data-siggo-val-panel]'));

      // Con una sola imagen no hay nada que rotar: el unico panel ya viene
      // marcado como activo desde el marcado.
      if (this.medias.length < 2 || this.panels.length < 2) return;

      this.current = 0;
      this.onCross = this.onCross.bind(this);

      /*
       * Banda fina en el centro de la pantalla (100% - 45% - 45% = 10%).
       * El observador solo sirve de disparador: avisa cuando alguna imagen
       * entra o sale de esa banda. Quien decide es `pickClosest`.
       */
      this.observer = new IntersectionObserver(this.onCross, {
        rootMargin: '-45% 0px -45% 0px',
        threshold: 0,
      });

      this.medias.forEach((media) => this.observer.observe(media));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onCross() {
      /*
       * En vez de fiarse de cual entrada del lote esta intersectando —que
       * dependeria del orden del lote al hacer scroll rapido— se mide donde
       * esta cada imagen y gana la que tenga el centro mas cerca del centro
       * de la pantalla. Son tres lecturas y el resultado es el mismo subiendo
       * que bajando, sin parpadeos en los saltos.
       */
      const middle = window.innerHeight / 2;
      let best = this.current;
      let bestDistance = Infinity;

      this.medias.forEach((media, index) => {
        const rect = media.getBoundingClientRect();
        const distance = Math.abs((rect.top + rect.bottom) / 2 - middle);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });

      this.activate(best);
    }

    activate(index) {
      if (index === this.current) return;
      this.current = index;

      this.panels.forEach((panel, position) => {
        const active = position === index;
        panel.classList.toggle('is-active', active);
        // Los paneles apagados salen del arbol de accesibilidad: estan
        // apilados uno encima de otro y si no, el lector los leeria los tres.
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
  }

  customElements.define('siggo-valores-sync', SiggoValoresSync);
})();
